import Axios from 'HHC/Axios';

export default (newHhuid, previousHhuid, identificationMechanism) =>
    Axios.post('/register_hhuid_change', { newHhuid, previousHhuid, identificationMechanism }).catch(console.error);
